module.exports = __webpack_public_path__ + "img/loginimg.54748751.png";